import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-modal.component.html',
  styleUrls: ['./document-modal.component.scss']
})
export class DocumentModalComponent {
  @Input() isOpen: boolean = false;
  @Input() documentTitle: string = '';
  @Input() zoomLevel: number = 100;

  @Output() close = new EventEmitter<void>();
  @Output() sign = new EventEmitter<void>();
  @Output() zoom = new EventEmitter<'in' | 'out'>();

  onZoom(direction: 'in' | 'out') {
    this.zoom.emit(direction);
  }
} 